import { Col, Row } from 'reactstrap';

import { capitalizeFirstLetter } from 'src/utils/string';
import CondicionalLookup from 'src/lookups/condicional';
import OrganizacaoLookup from 'src/lookups/item-organizacao';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

import { hasSearchMatch } from './searchUtils';

const InteresseOutrasAreasSection = ({ model, resources, intl, campos, searchQuery }) => {
  if (!campos[COLABORADOR_CAMPOS.INTERESSE_OUTRAS_AREAS]) return null;

  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);
  const sectionTerms = [
    intl.formatMessage({ id: 'interesseOutrasAreas' }),
    capitalizeFirstLetter(intl.formatMessage({ id: 'interesse' })),
    capitalizeFirstLetter(
      intl.formatMessage(
        { id: 'areasInteresse' },
        { areas: resources?.area }
      )
    ),
  ];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={intl.formatMessage({ id: 'interesseOutrasAreas' })}>
      <Row>
        {fieldMatches([intl.formatMessage({ id: 'interesse' })]) && (
          <Col md={12}>
            <CondicionalLookup
              clearable
              model={{
                label: capitalizeFirstLetter(intl.formatMessage({ id: 'interesse' })),
                value: model.getModel('interesseOutrasAreas').value,
                requestChange: model.getModel('interesseOutrasAreas').requestChange,
                errors: model.getModel('interesseOutrasAreas').errors,
              }}
            />
          </Col>
        )}
        {fieldMatches([
          intl.formatMessage(
            { id: 'areasInteresse' },
            { areas: resources?.area }
          ),
        ]) && (
          <Col md={12}>
            <OrganizacaoLookup
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'areasInteresse' },
                    { areas: resources.area }
                  )
                ),
                value: model.getModel('areaInteresse').value,
                requestChange: model.getModel('areaInteresse').requestChange,
                errors: model.getModel('areaInteresse').errors,
              }}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default InteresseOutrasAreasSection;
